var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-config-provider",
    { attrs: { prefixCls: _vm.antPrefix } },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }